<template>
	<div class="user-management">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">{{ toTitleCase(activePage) }} Management</h1>
				<div class="page-header-right text-right ml-a">
					<!-- Date Filter -->
					<daterangepicker
						:presets="filterDatePresets"
						:start="since"
						:end="until"
						@selected="setFilterDate"
						ref="datePicker"
					>
					</daterangepicker>
				</div>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-6">
							<div class="table-actions flex-center" v-if="isAdmin">
								<button
									class="btn btn-primary btn-sm"
									@click="isShowCreateItem = true"
								>
									<i class="material-icons">add</i><span>Add New {{toTitleCase(activePage)}}</span>
								</button>
								<div class="dropdown">
									<button
										class="btn btn-light btn-sm dropdown-toggle"
										:disabled="selectedItems.length === 0"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										Actions
									</button>
									<div class="dropdown-menu">
										<!-- <div
											class="dropdown-item"
											@click="isShowChangePackage = true"
										>
											Change Package
										</div> -->
										<div
											class="dropdown-item"
											@click="isShowChangeExpiration = true"
										>
											Change Expired Date
										</div>
										<div
											class="dropdown-item"
											@click="isShowChangeStatus = true"
										>
											Change Status
										</div>
										<div
											class="dropdown-item"
											@click="isShowChangePassword = true"
										>
											Change Password
										</div>
										<div
											class="dropdown-item"
											@click="isShowChangePaymentType = true"
										>
											Change Payment Type
										</div>
										<button
											class="dropdown-item"
											:class="{ 'disabled':selectedItems.length > 1 }"
											@click="openModalUpdateFeatures(selectedItems[0])">
											{{ $t('Update Features') }}
										</button>
										<button
											class="dropdown-item"
											:class="{ 'disabled':selectedItems.length > 1 }"
											@click="openModalServiceFee(selectedItems[0])">
											{{ $t('Update Service Fee') }}
										</button>
									</div>
								</div>
								<button
									class="btn btn-light btn-sm btn-icon-danger"
									:class="{ 'is-loading': isDeleting }"
									:disabled="selectedItems.length === 0"
									@click="isShowDeleteBulk = true"
								>
									<i class="material-icons">delete</i>
									<span>Delete</span>
								</button>
								<!-- Selected Label -->
								<div
									class="btn btn-plain btn-sm disabled"
									v-if="selectedItems.length > 0"
								>
									<span
										><b>{{ selectedItems.length }}</b> Selected User</span
									><span v-if="selectedItems.length > 1">s</span>
								</div>
							</div>
						</div>
						<div class="col-sm-6">
							<div class="table-filters d-flex justify-content-end align-items-center ml-a">
								<!-- Clear Filter -->
								<button
									type="button"
									class="btn btn-plain btn-sm"
									@click="clearFilter"
									v-if="isFilterOn"
								>
									{{ $t('Clear Filter') }}
								</button>
								<!-- Export -->
								<div class="dropdown export">
									<button
										type="button"
										class="btn btn-light btn-sm dropdown-toggle flex-center"
										data-toggle="dropdown"
										:class="{ 'is-loading': isExporting }"
									>
										<i class="material-icons">save_alt</i>
										<span class="mr-2">{{ $t('Export') }}</span>
									</button>
									<div class="dropdown-menu">
										<button
											type="button"
											class="dropdown-item"
											:class="{ 'is-loading': isExporting }"
											@click="exportSuppliers('filtered')">
											{{ $t('Export Filtered') }}
										</button>
										<button
											type="button"
											class="dropdown-item"
											:class="{ 'is-loading': isExporting }"
											@click="exportSuppliers('all')">
											{{ $t('Export All') }}
										</button>
									</div>
								</div>
								<!-- Filter -->
								<button type="button" class="filter-toggle btn btn-light btn-sm btn-icon" @click="isShowFilter = true">
									<i class="material-icons mr-1">filter_list</i>Filter {{ toTitleCase(activePage) }}
								</button>
								<!-- Search Keyword -->
								<input
									type="text"
									class="input form-control form-control-sm users-search-box"
									placeholder="Search Users.."
									autocomplete="off"
									@input="onKeywordChange"
									v-model="keyword"
								/>
							</div>
						</div>
					</div>
				</div>
				<!-- Users List -->
				<div class="users-list table-responsive">
					<div v-if="role_type == 'owner'">
						<users-table-owner
							:items.sync="items"
							:activePage="activePage"
							@selectedItems="onSelectedItems"
							@sorting="onSorting"
							@followUp="followUp"
							@editUserEmail="editUserEmail"
							@verifUser="verifUser"
							@seller-profile="openSellerProfile"
							@supplier-profile="openSupplierProfile"
							@seller-connection="openSellerConnection"
							@change-expired-date="openChangeExpiration"
						>
						</users-table-owner>
					</div>
					<div v-else>
						<users-table-non-owner
							:items.sync="items"
							@selectedItems="onSelectedItems"
							@sorting="onSorting"
							@followUp="followUp"
							@editUserEmail="editUserEmail"
							@editUserRole="editUserRole"
							@seller-profile="openSellerProfile"
							@supplier-profile="openSupplierProfile"
						>
						</users-table-non-owner>
					</div>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<div
						class="list-empty"
						v-if="items.length === 0 && isFetching === false"
					>
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no users yet.</span>
						<span v-else>No users was found</span>
					</div>
				</div>
			</div>
		</div>
		<!-- Modals -->
		<div class="modals">
			<update-user-feature
				type="sellers"
				:isShow="isShowUpdateFeatures"
				:user="userDetail"
				@updateUser="updateUser"
				@close="closeModalUpdateFeatures"
			/>
			<!-- Modal Filter -->
			<modal
			class="table-filter-modal"
			size="medium"
			@close="isShowFilter = false"
			v-if="isShowFilter">
			<div slot="header">
				<h3><i class="material-icons">filter_list</i>Filter Users</h3>
			</div>
			<div slot="body">
				<!-- role -->
				<!-- <div v-if="role_type == 'owner'" class="form-group">
					<label for="">
						<b class="">
							Role Account
						</b>
					</label>
					<select class="form-control" v-model="owner_type">
						<option value="all">All</option>
						<option value="supplier">Supplier</option>
						<option value="dropshipper">Seller</option>
					</select>
				</div> -->
				<!-- status -->
				<div class="form-group">
					<label for="">
						<b class="">
							Status Account
						</b>
					</label>
					<select class="form-control" v-model="is_active">
						<option value="all">All</option>
						<option value="true">Active</option>
						<option value="false">Non Active</option>
					</select>
				</div>
				<!-- identity_status -->
				<div v-if="role_type == 'owner'" class="form-group">
					<label for="">
						<b class="">
							Status Verification
						</b>
					</label>
					<select class="form-control" v-model="identity_status">
						<option value="all">All</option>
						<option value="requested">Requested</option>
						<option value="skipped">Skipped</option>
						<option value="rejected">Rejected</option>
						<option value="approved">Approved</option>
					</select>
				</div>
				<!-- source_type -->
				<div v-if="role_type == 'owner'" class="form-group">
					<label for="">
						<b class="">
							Source Type
						</b>
					</label>
					<select class="form-control text-capitalize" v-model="source_type">
						<option :value="sourceType.value"
							v-for="(sourceType, idx) in sourceTypes"
							:key="idx">{{ sourceType.label }}</option>
					</select>
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isShowFilter = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-primary" @click="applyFilter">Apply</button>
			</div>
		</modal>

			<!-- Bulk Delete Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				v-if="isShowDeleteBulk"
				@close="isShowDeleteBulk = false"
			>
				<div slot="header">
					<h3><i class="material-icons">delete</i>Delete User</h3>
				</div>
				<div slot="body">
					Are you sure want to delete {{ selectedItems.length }} users?
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDeleteBulk = false"
					>
						{{ $t('Close') }}
					</button>
					<button type="button" class="btn btn-danger" @click="bulkDelete">
						Delete
					</button>
				</div>
			</modal>

			<!-- Delete Confirm -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				v-if="isShowDelete"
				@close="isShowDelete = false"
			>
				<div slot="header">
					<h3><i class="material-icons">delete</i>Delete User</h3>
				</div>
				<div slot="body">
					Are you sure want to delete {{ selectedItem.name }}?
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowDelete = false"
					>
						{{ $t('Close') }}
					</button>
					<button type="button" class="btn btn-danger" @click="deleteProduct">
						Delete
					</button>
				</div>
			</modal>

			<!-- Add New User -->
			<modal
				class="coupon-editor-modal"
				size="medium"
				v-if="isShowCreateItem"
				@close="isShowCreateItem = false"
			>
				<div slot="header">
					<h3><i class="material-icons">add</i>Create User</h3>
				</div>
				<div slot="body">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12">
								<div class="form-group" :class="{'hidden' : !isUserCan('admin_users_staff_view') || activePage !== 'staff'}">
									<label><b>Role</b></label>
									<select class="form-control" v-model="userData.role">
										<option v-if="this.isAdmin" value="admin">Admin</option>
										<option v-if="this.isAdmin" value="superadmin">Super Admin</option>
										<option v-if="this.isAdmin" value="finance">Finance</option>
										<option v-if="this.isAdmin" value="admin_order">Admin Order</option>
										<option v-if="this.isAdmin" value="admin_content">Admin Content</option>
										<!-- <option value="owner">Owner</option> -->
									</select>
								</div>
								<!-- <div v-if="userData.role == 'owner'" class="form-group">
									<label><b>Owner Type</b></label>
									<select class="form-control" v-model="userData.owner_type">
										<option value="">Choose Owner Type</option>
										<option value="supplier">Supplier</option>
										<option value="dropshipper">Seller</option>
									</select>
								</div> -->
								<div class="form-group">
									<label><b>Name</b></label>
									<input
										v-focus
										type="text"
										name="name"
										class="input form-control"
										placeholder="Name"
										autocomplete="off"
										v-model="userData.name"
									/>
								</div>
								<!-- <div class="form-group">
									<label><b>Username</b></label>
									<input
										type="text"
										name="username"
										class="input form-control"
										placeholder="Username"
										autocomplete="off"
										v-model="userData.username"
									/>
								</div> -->
								<div class="form-group">
									<label><b>Email</b></label>
									<input
										type="email"
										name="email"
										class="input form-control"
										placeholder="Email"
										autocomplete="off"
										v-model="userData.email"
									/>
								</div>
								<div class="form-group">
									<label><b>Password</b></label>
									<input
										type="password"
										name="password"
										class="input form-control"
										placeholder="Password"
										autocomplete="off"
										v-model="userData.password"
									/>
								</div>

								<div class="form-group">
									<label><b>Phone</b></label>
									<input
										type="tel"
										name="phone"
										class="input form-control"
										placeholder="+628xxx"
										autocomplete="off"
										v-model="userData.phone"
									/>
								</div>
								<div v-if="userData.owner_type == 'supplier'" class="form-group">
									<label><b>Business Name</b></label>
									<input
										type="text"
										name="name"
										class="input form-control"
										placeholder="Business Name"
										autocomplete="off"
										v-model="userData.business_name"
									/>
								</div>
								<div v-if="userData.owner_type == 'supplier'" class="form-group">
									<label><b>Business Address</b></label>
									<textarea
										type="textarea"
										name="name"
										class="input form-control"
										placeholder="Business Address"
										autocomplete="off"
										v-model="userData.business_address"
									/>
								</div>
								<!-- <div class="form-group">
									<label><b>Package</b></label>
									<multiselect
										placeholder="Select Package.."
										:options="packages"
										:taggable="false"
										:show-labels="false"
										:show-no-results="true"
										:label="'label'"
										:track-by="'name'"
										:preselect-first="true"
										:allow-empty="false"
										v-model="selectedPackage"
										@select="onSelectPackage"
									>
										<span slot="noResult">No Package found.</span>
									</multiselect>
								</div> -->
								<!-- <div class="form-group">
									<label><b>Expired In</b></label>
									<select class="form-control" v-model="userData.expired_at">
										<option
											v-for="(packageLength, index) in packagesLength"
											:key="index"
											:value="packageLength.value"
										>
											{{ packageLength.label }}
										</option>
									</select>
								</div> -->
							</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowCreateItem = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isCreating }"
						@click="createUser"
					>
						Create User
					</button>
				</div>
			</modal>

			<!-- Change Package -->
			<modal
				size="small"
				v-if="isShowChangePackage"
				@close="isShowChangePackage = false"
			>
				<div slot="header"><h3>Change Package</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Package</b></label>
						<multiselect
							placeholder="Select Package.."
							:options="packages"
							:taggable="false"
							:show-labels="false"
							:show-no-results="true"
							:label="'name'"
							:track-by="'name'"
							:preselect-first="true"
							:allow-empty="false"
							v-model="selectedPackage"
						>
							<span slot="noResult">No Package found.</span>
						</multiselect>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangePackage = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingPackage }"
						@click="updatePackage"
					>
						Update Package
					</button>
				</div>
			</modal>

			<!-- Change Expiration Date -->
			<modal
				size="small"
				v-if="isShowChangeExpiration"
				@close="isShowChangeExpiration = false"
			>
				<div slot="header"><h3>Change Expired Date</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Expired Date</b></label>
						<input
							type="date"
							name="expiration_date"
							class="form-control"
							v-model="expirationDate"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangeExpiration = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingExpiration }"
						@click="updateExpiration"
					>
						Update Expiration
					</button>
				</div>
			</modal>

			<!-- Change Status -->
			<modal
				size="small"
				v-if="isShowChangeStatus"
				@close="isShowChangeStatus = false"
			>
				<div slot="header"><h3>Change Status</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Status</b></label>
						<select class="form-control" v-model="selectedStatus">
							<option :value="1">Active</option>
							<option :value="0">Inactive</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangeStatus = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingStatus }"
						@click="updateStatus"
					>
						Update Status
					</button>
				</div>
			</modal>

			<!-- Change Password -->
			<modal
				size="small"
				v-if="isShowChangePassword"
				@close="isShowChangePassword = false"
			>
				<div slot="header"><h3>Change Password</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Password</b></label>
						<input
							type="password"
							name="new_password"
							class="form-control"
							placeholder="New Password"
							v-model="selectedPassword"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangePassword = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingPassword }"
						@click="updatePassword"
					>
						Update Password
					</button>
				</div>
			</modal>

			<!-- Change Payment Type -->
			<modal
				size="small"
				v-if="isShowChangePaymentType"
				@close="isShowChangePaymentType = false"
			>
				<div slot="header"><h3>Change Payment Type</h3></div>
				<div slot="body">
					<div class="form-group">
						<label><b>Payment Type</b></label>
						<select class="form-control" v-model="selectedPaymentType">
							<option value="netoff">netoff</option>
							<option value="invoice">invoice</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowChangePaymentType = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingPaymentType }"
						@click="updatePaymentType"
					>
						Update Payment Type
					</button>
				</div>
			</modal>

			<!-- Change Email -->
			<modal
				size="small"
				@close="isEditEmailVisible = false"
				v-if="isEditEmailVisible"
			>
				<div slot="header">
					<h3>Change Email</h3>
				</div>
				<div slot="body">
					<div class="form-group">
						<label><b>Email</b></label>
						<input
							type="text"
							name="new_email"
							class="form-control"
							placeholder="New Email"
							v-model="userNewEmail"
						/>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isEditEmailVisible = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingEmail }"
						@click="updateEmail"
					>
						Update Email
					</button>
				</div>
			</modal>

			<!-- Change Role -->
			<modal
				size="small"
				@close="isEditRoleVisible = false"
				v-if="isEditRoleVisible"
			>
				<div slot="header">
					<h3>Change Role</h3>
				</div>
				<div slot="body">
					<div class="form-group">
						<select class="form-control" v-model="selectedItem.role">
							<option v-for="role in optionAdminRoles" :value="role.value" :key="role.value">{{role.label}}</option>
						</select>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isEditRoleVisible = false"
					>
						Cancel
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isUpdatingRole }"
						@click="updateRole"
					>
						Update Role
					</button>
				</div>
			</modal>

			<!-- Details -->
			<user-details
				:user="userDetail"
				v-if="isDetailsVisible && !!userDetail"
				@close="isDetailsVisible = false"
			/>

			<!-- Selected Users -->
			<!-- <modal
				@close="isSelectedListVisible = false"
				v-if="isSelectedListVisible">
				<template slot="header">
					<h3>Selected Users</h3>
				</template>
				<template slot="body">
					{{ selectedItems }}
				</template>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-primary"
						@click="isSelectedListVisible = false">
						OK
					</button>
				</template>
			</modal> -->

			<!-- modal show team member -->
			<!-- Change Status -->
			<modal
				size="large"
				v-if="isShowTeamMember"
				@close="isShowTeamMember = false"
			>
				<div slot="header">
					<h3>{{ $t('menu.members') }}</h3>
				</div>
				<div slot="body">
					<div class="">
						<!-- Main Table -->
						<div class="table-responsive">
							<table class="table table-striped table--small">
								<thead>
									<tr>
										<th width="3%" class="th-sort">No</th>
										<th width="5%" class="align-middle p-0"></th>
										<th class="text-left th-sort">Name</th>
										<th class="text-left th-sort hidden-sm">Email</th>
										<th class="text-left hidden-sm">Phone</th>
										<th class="text-left th-sort hidden-sm">Role</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(member, index) in teamMembers" :key="member._id">
										<td>{{ index + 1 }}.</td>
										<td class="align-middle text-center pt-0 pb-0">
											<div class="member-picture">
												<img
													:src="member.picture"
													:alt="member.name"
													v-if="member.picture"
												/>
												<i class="material-icons" v-if="!member.picture"
													>account_box</i
												>
											</div>
										</td>
										<td>
											<div class="member-name">{{ member.name }}</div>
										</td>
										<td>
											<div class="member-email">{{ member.email }}</div>
										</td>
										<td>
											<div class="member-phone" v-if="member.phone">
												{{ member.phone }}
											</div>
										</td>
										<td>
											<div class="member-role">{{ member.role }}</div>
										</td>
										<!-- <td>
										<div class="member-date">{{ moment(member.created_at).format('DD-MM-YYYY') }}</div>
									</td> -->
									</tr>
								</tbody>
							</table>
						</div>

						<!-- Table Loader -->
						<div class="table-fetch-status" v-if="isFetchingMember">
							<div class="is-loading large dark m-auto"></div>
						</div>

						<!-- Table Empty -->
						<div
							class="list-empty"
							v-if="teamMembers.length === 0 && isFetchingMember === false"
						>
							<i class="material-icons md-48 mr-2">error_outline</i>
							<span>No member was found</span>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button
						type="button"
						class="btn btn-light"
						@click="isShowTeamMember = false"
					>
						Closed
					</button>
				</div>
			</modal>

			<!-- Follow Up -->
			<follow-up-modal
				:name="followUpName"
				:number="followUpNumber"
				:message="followUpMessage"
				@close="hideFollowUp"
				v-if="isFollowUpVisible"
			/>

			<!-- Modal User Verification -->
			<modal-user-verification
				:user="selectedItem"
				:source="verificationModalSource"
				@close="closeModalVerification"
				@update="updateUserIdentity"
				@back-seller="openSellerProfileFromVerification"
				@back-supplier="openSupplierProfileFromVerification"
				v-if="isModalVerificationVisible"
			/>

			<!-- Modal Seller Profile -->
			<modal-seller-profile
				:user="selectedItem"
				@close="closeSellerProfile"
				@verification="openVerificationFromSellerProfile"
				v-if="isModalSellerProfileVisible"
			/>

			<!-- Modal Supplier Profile -->
			<modal-supplier-profile
				:user="selectedItem"
				@close="closeSupplierProfile"
				@verification="openVerificationFromSupplierProfile"
				v-if="isModalSupplierProfileVisible"
			/>

			<!-- Modal Seller Connection -->
			<modal-seller-connection
				:user="selectedItem"
				@close="closeModalSellerConnection"
				v-if="isModalModalSellerConnectionVisible"
			/>

			<!-- Modal User Service Fee -->
			<modal-user-service-fee
				:user="selectedUser"
				@update="updateUserServiceFee"
				@close="isShowModalServiceFee = false"
				v-if="isShowModalServiceFee"
			/>
		</div>

		<!-- Notifications -->
		<notifications group="users" position="bottom right" />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Modal from '@/components/Modal.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
import UserDetails from '@/components/UserDetails.vue';
import FollowUpModal from '@/components/FollowUpModal.vue';
import UsersTableOwner from '@/components/UsersTableOwner.vue';
import UsersTableNonOwner from '@/components/UsersTableNonOwner.vue';
import ModalUserVerification from '@/components/ModalUserVerification.vue';
import ModalSellerProfile from '@/components/ModalSellerProfile.vue';
import ModalSupplierProfile from '@/components/ModalSupplierProfile.vue';
import ModalUserServiceFee from '@/components/ModalUserServiceFee.vue';
import ModalSellerConnection from '@/components/ModalSellerConnection.vue';
import {
	defaultPackages,
	defaultPackagesLength,
	defaultUserData,
	defaultFollowUpMessage,
	sourceTypeOptions,
	adminRolesOptions,
} from '@/lib/statics';
import {
	duplicateVar,
	formatMoney,
	getDateRange,
	getAxiosErrorMessage,
	formatWaNumber,
	downloadFile,
	toTitleCase,
} from '@/lib/helper';
import usersApi from '@/api/user';
import userPackageApi from '@/api/userPackage';
import settingApi from '@/api/setting';
import adminApi from '@/api/admin';
import UpdateUserFeature from '@/components/UpdateUserFeature.vue';

const teams = [
	{
		_id: '5ea63cfe84d07351ea38d45b',
		name: 'CS 4',
		email: 'cs4.orderonline@gmail.com',
		phone: '+62121212121212121',
		picture: '',
		is_active: true,
		on_duty: false,
		role: 'cs',
		created_at: '2020-04-27 02:01:34',
	},
	{
		_id: '5ce240959f05aa74144754f7',
		name: 'Irfan',
		email: 'old-ordivo.id@gmail.com',
		phone: '+8285255255255',
		picture: '',
		is_active: true,
		role: 'cs',
		created_at: '2019-05-20 05:52:21',
		on_duty: true,
	},
	{
		_id: '5c6103ac9f05aa58b7258962',
		name: 'Putra',
		email: 'thejampang78@gmail.com',
		phone: '+6285255255112',
		picture: '',
		is_active: true,
		role: 'cs',
		created_at: '2019-02-11 05:10:04',
		on_duty: true,
	},
	{
		_id: '5b7b7d789f05aa11cd658982',
		name: 'Maul',
		email: 'csbarus@gmail.com',
		phone: '+6283100223332',
		picture: '',
		is_active: true,
		role: 'cs',
		created_at: '2018-08-21 02:48:24',
		on_duty: true,
	},
	{
		_id: '5b71d2809f05aa32070e19e2',
		name: 'Ekhy',
		email: 'shipper@gmail.com',
		phone: '',
		picture: '',
		is_active: true,
		role: 'shipper',
		created_at: '2018-08-13 18:48:32',
		on_duty: true,
	},
	{
		_id: '5b6e91d99f05aa59c12dfd54',
		name: 'Rofy Korda',
		email: 'rofy@gmail.com',
		picture: '',
		is_active: true,
		role: 'admin',
		created_at: '2018-08-11 07:35:53',
		phone: '+62808080',
		on_duty: true,
	},
	{
		_id: '5b6e8f5b9f05aa57a003b962',
		name: 'Jaya',
		email: 'rovan_63@yahoo.co.id',
		picture: 'https://images.orderonline.id/8537051534144883911.png',
		is_active: true,
		role: 'cs',
		created_at: '2018-08-11 07:25:15',
		phone: '+6285862749672',
		on_duty: true,
	},
];

export default {
	name: 'userManagement',
	components: {
		Modal,
		Daterangepicker,
		UserDetails,
		FollowUpModal,
		ModalUserVerification,
		UsersTableOwner,
		UsersTableNonOwner,
		ModalSellerProfile,
		ModalSupplierProfile,
		ModalSellerConnection,
		UpdateUserFeature,
		ModalUserServiceFee,
	},
	data() {
		return {
			userData: duplicateVar(defaultUserData),
			items: [],
			selectedItems: [],
			selectedItem: null,
			keyword: '',
			limit: 20,
			sort_by: 'created_at',
			sort: 'asc',
			isAll: false,
			isFetching: false,
			isFetchingSetting: false,
			isCreating: false,
			isDeleting: false,
			isShowDelete: false,
			isShowDeleteBulk: false,
			isShowCreateItem: false,
			isShowChangePackage: false,
			isShowChangeStatus: false,
			isShowChangePassword: false,
			isShowChangeExpiration: false,
			isShowChangePaymentType: false,
			isUpdatingPackage: false,
			isUpdatingStatus: false,
			isUpdatingPassword: false,
			isUpdatingExpiration: false,
			isUpdatingPaymentType: false,
			isEditEmailVisible: false,
			packages: duplicateVar(defaultPackages),
			packagesLength: defaultPackagesLength,
			selectedPackage: null,
			selectedPackageLength: null,
			selectedStatus: 1,
			selectedPassword: null,
			selectedPaymentType: 'netoff',
			expirationDate: '1992-12-24',
			since: null,
			until: null,
			userNewEmail: '',
			isUpdatingEmail: false,
			userDetail: null,
			isDetailsVisible: false,
			isShowTeamMember: false,
			isFetchingMember: false,
			teamMembers: teams,
			isShowFilter: false,
			identity_status: 'all',
			source_type: 'all',
			sourceTypes: duplicateVar(sourceTypeOptions),
			is_active: 'all',
			role_type: 'owner',
			owner_type: '',
			followUpNumber: '',
			followUpName: '',
			followUpMessage: '',
			followUpMessages: '',
			isFollowUpVisible: false,
			isModalVerificationVisible: false,
			isModalSellerProfileVisible: false,
			isModalSupplierProfileVisible: false,
			isModalModalSellerConnectionVisible: false,
			verificationModalSource: 'direct',
			isEditRoleVisible: false,
			isUpdatingRole: false,
			optionAdminRoles: adminRolesOptions,
			isExporting: false,
			isShowUpdateFeatures: false,
			isShowModalServiceFee: false,
			selectedUser: null,
		};
	},
	methods: {
		...mapActions({}),
		toTitleCase,
		checkIdentityStatus() {
			const query = duplicateVar(this.$route.query);
			if (query.verification) {
				this.identity_status = query.verification;
				this.changeSort('created_at', 'desc');
			}
		},
		changeSort(sortBy, order) {
			this.sort_by = sortBy;
			this.sort = order;
		},
		resetItems() {
			this.items = [];
			this.selectedItems = [];
			this.isAll = false;
			this.page = 1;
		},
		checkPage() {
			if (this.activePage === 'staff') {
				this.role_type = 'non-owner';
				this.owner_type = '';
			}
			if (this.activePage === 'supplier') {
				this.role_type = 'owner';
				this.owner_type = 'supplier';
			}
			if (this.activePage === 'seller') {
				this.role_type = 'owner';
				this.owner_type = 'dropshipper';
			}

			this.userData.role = this.role_type;
			this.userData.owner_type = this.owner_type;
		},
		changePage() {
			this.checkPage();
			this.fetchUsers();
		},
		exportSuppliers(type = 'filtered') {
			this.isExporting = true;
			const params = this.fetchParams();
			if (type === 'all') {
				delete params.since;
				delete params.until;
			}
			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			adminApi.exportUsers(params, callback, errorCallback);
		},
		fetchParams() {
			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: this.since,
				until: this.until,
			};

			if (this.role_type) {
				params.role_type = this.role_type;
			}

			if (this.owner_type !== 'all') {
				params.owner_type = this.owner_type;
			}

			if (this.identity_status !== 'all') {
				params.identity_status = this.identity_status;
			}

			if (this.source_type !== 'all') {
				params.source_type = this.source_type;
			}

			if (this.is_active !== 'all') {
				params.is_active = this.is_active;
			}

			if (this.userId) {
				params.user_id = this.userId;
			}

			const keyword = this.keyword.trim();
			if (keyword !== '') {
				params.keyword = keyword;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.fetchParams();

			const callback = (response) => {
				this.isFetching = false;
				const users = response.data;
				if (users.length > 0) {
					this.page++;
					this.items = this.items.concat(users);
				} else {
					this.isAll = true;
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			if (this.isAdmin) {
				usersApi.getUsers(params, callback, errorCallback);
			} else if (this.isSupport) {
				usersApi.getUsersMinimal(params, callback, errorCallback);
			}
		},
		transformSourceType(sourceType) {
			const item = {
				value: sourceType,
				label: sourceType,
			};

			return item;
		},
		fetchSourceTypes() {
			const callback = (response) => {
				this.isFetching = false;
				const rawSourceTypes = response.data;
				if (rawSourceTypes.length > 0) {
					this.sourceTypes = [];
					this.sourceTypes = duplicateVar(sourceTypeOptions); // Reset with default value
					rawSourceTypes.forEach((sourceType) => {
						const item = this.transformSourceType(sourceType._id);
						this.sourceTypes.push(item);
					});
				}
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			usersApi.getSourceTypes(callback, errorCallback);
		},
		onKeywordChange() {
			// const self = this;
			this.ooDelay(() => {
				if (this.isAdmin) {
					this.fetchItems();
				} else if (this.isSupport) {
					if (this.keyword.trim() === '') {
						this.resetItems();
					} else {
						this.fetchItems();
					}
				}
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		bulkDelete() {
			this.isDeleting = true;
			const userIds = this.selectedItems.slice();
			const callback = () => {
				this.isDeleting = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const id = this.selectedItems[i];
					const index = this.items.findIndex(item => item._id === id);
					const isIndex = index !== -1;
					if (isIndex) {
						this.items.splice(index, 1);
					}
				}
				this.$set(this, 'selectedItems', []);

				this.isShowDeleteBulk = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'Users deleted',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isDeleting = false;
				this.isShowDeleteBulk = false;
			};
			usersApi.bulkDelete(userIds, callback, errorCallback);
		},
		delete() {
			this.isDeleting = true;
			const callback = () => {
				this.isDeleting = false;
				const id = this.selectedItem._id;
				const index = this.items.findIndex(item => item._id === id);
				const isIndex = index !== -1;
				if (isIndex) {
					this.items.splice(index, 1);
				}
				this.$set(this, 'selectedItem', null);
				this.isShowDeleteProduct = false;
				this.$notify({
					group: 'products',
					title: 'Products',
					text: 'Product deleted',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isDeleting = false;
				this.isShowDeleteProduct = false;
			};
			const userIds = [this.selectedItem._id];
			usersApi.bulkDelete(userIds, callback, errorCallback);
		},
		closeModalUpdateFeatures() {
			this.isShowUpdateFeatures = false;
		},
		updateUser(newFeature) {
			const userId = this?.userDetail?._id;
			const user = this.items.find(user => user._id === userId);
			if (user) {
				const currentFeature = user?.features ?? [];
				if (!currentFeature.includes(newFeature)) {
					user.features = [...currentFeature, newFeature];
				}
			}
		},
		openModalUpdateFeatures(userId) {
			if (this.selectedItems.length === 1) {
				const user = this.items.find(x => x._id === userId);
				this.userDetail = user;
				this.isShowUpdateFeatures = true;
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		showConfirmDeleteProduct(item) {
			this.selectedItem = item;
			this.isShowDelete = true;
		},
		formatDate(date) {
			return this.moment(date).format('DD-MM-YYYY');
		},
		formatDateWithTime(date) {
			return this.moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		createUser() {
			this.isCreating = true;
			const params = duplicateVar(this.userData);
			const callback = (response) => {
				this.isCreating = false;
				const user = response.data;
				this.items.push(user);

				this.userData = duplicateVar(defaultUserData);
				this.isShowCreateItem = false;

				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'User has been created',
					type: 'success',
				});
			};
			const errorCallback = (e) => {
				this.isCreating = false;
				const message = e.response.message;
				// this.isShowCreateItem = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: message,
					type: 'error',
				});
			};
			usersApi.create(params, callback, errorCallback);
		},
		onSelectPackage(plan) {
			this.userData.package = plan.name;
		},
		updatePackage() {
			this.isUpdatingPackage = true;
			const userIds = this.selectedItems.slice();
			const packageName = this.selectedPackage.name;
			const callback = () => {
				this.isUpdatingPackage = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const userId = this.selectedItems[i];
					const user = this.items.find(user => user._id === userId);
					if (user) {
						user.package = packageName;
					}
				}
				this.isShowChangePackage = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'Users package has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingPackage = false;
				this.isShowChangePackage = false;
			};
			usersApi.bulkChangePackage(userIds, packageName, callback, errorCallback);
		},
		updateStatus() {
			this.isUpdatingStatus = true;
			const userIds = this.selectedItems.slice();
			const status = this.selectedStatus;
			const callback = () => {
				this.isUpdatingStatus = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const userId = this.selectedItems[i];
					const user = this.items.find(user => user._id === userId);
					if (user) {
						const isActive = status === 1;
						user.is_active = isActive;
					}
				}
				this.isShowChangeStatus = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'Users status has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingStatus = false;
				this.isShowChangeStatus = false;
			};
			usersApi.bulkChangeStatus(userIds, status, callback, errorCallback);
		},
		updatePassword() {
			this.isUpdatingPassword = true;
			const userIds = this.selectedItems.slice();
			const password = this.selectedPassword;
			const callback = () => {
				this.isUpdatingPassword = false;
				this.isShowChangePassword = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'Users password has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingPassword = false;
				this.isShowChangePassword = false;
			};
			usersApi.bulkChangePassword(userIds, password, callback, errorCallback);
		},
		updatePaymentType() {
			this.isUpdatingPaymentType = true;
			const userIds = this.selectedItems.slice();
			const paymentType = this.selectedPaymentType;
			const callback = () => {
				this.isUpdatingPaymentType = false;
				this.isShowChangePaymentType = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'Users payment type has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingPaymentType = false;
				this.isShowChangePaymentType = false;
			};
			usersApi.bulkChangePaymentType(userIds, paymentType, callback, errorCallback);
		},
		updateExpiration() {
			// eslint-disable-next-line no-restricted-globals
			if (!confirm('Apakah Anda yakin ingin mengubah tanggal expired user yang terpilih?')) {
				return;
			}
			this.isUpdatingExpiration = true;
			const userIds = this.selectedItems.slice();
			const expirationDate = this.expirationDate;
			const callback = () => {
				this.isUpdatingExpiration = false;
				for (let i = 0; i < this.selectedItems.length; i++) {
					const userId = this.selectedItems[i];
					const user = this.items.find(user => user._id === userId);
					if (user) {
						user.expired_date = `${expirationDate} 23:59:59`;
					}
				}
				this.isShowChangeExpiration = false;
				this.$notify({
					group: 'users',
					title: 'Users',
					text: 'Users expiration has been updated',
					type: 'success',
				});
			};
			const errorCallback = () => {
				this.isUpdatingExpiration = false;
				this.isShowChangeExpiration = false;
			};
			usersApi.bulkChangeExpiredDate(
				userIds,
				expirationDate,
				callback,
				errorCallback,
			);
		},
		openChangeExpiration(user) {
			this.selectedItems = [user._id];
			this.expirationDate = user.expired_date ? dayjs(user.expired_date).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD');
			this.isShowChangeExpiration = true;
		},
		fetchPackages() {
			const callback = (response) => {
				const packages = response.data;
				this.packages = packages;
			};
			const errorCallback = () => {};
			userPackageApi.getPackages(callback, errorCallback);
		},
		formatMoney(str) {
			return formatMoney(str);
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const dateFormat = 'YYYY-MM-DD';
			const since = dayjs(filterDate.start).format(dateFormat);
			const until = dayjs(filterDate.end).format(dateFormat);
			this.since = since;
			this.until = until;
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			// this.fetchItems(true);
		},
		initFilterDate() {
			const dateRange = getDateRange();
			const hasSinceQuery = this.sinceQuery && this.sinceQuery !== '';
			const hasUntilQuery = this.untilQuery && this.untilQuery !== '';
			const sinceDate = hasSinceQuery
				? dayjs(this.sinceQuery)
				: dayjs(dateRange.start);
			const untilDate = hasUntilQuery
				? dayjs(this.untilQuery)
				: dayjs(dateRange.end);
			const filterDate = {
				start: sinceDate,
				end: untilDate,
			};
			this.filterDate = filterDate;

			const dateFormat = 'YYYY-MM-DD';
			this.since = sinceDate.format(dateFormat);
			this.until = untilDate.format(dateFormat);
		},
		editUserEmail(user) {
			this.selectedItem = duplicateVar(user);
			this.userNewEmail = duplicateVar(user.email);
			this.isEditEmailVisible = true;
		},
		editUserRole(user) {
			this.selectedItem = duplicateVar(user);
			this.isEditRoleVisible = true;
		},
		updateEmail() {
			this.isUpdatingEmail = true;
			const userId = this.selectedItem._id;
			const email = this.userNewEmail.trim();
			const params = {
				email,
			};
			const callback = (response) => {
				this.updateEmailInList(userId, email);
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'User Update Email',
					text: message,
					type: 'success',
				});
				this.isUpdatingEmail = false;
				this.isEditEmailVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'User Update Email',
					text: message,
					type: 'danger',
				});
				this.isUpdatingEmail = false;
			};
			usersApi.update(userId, params, callback, errorCallback);
		},
		updateRole() {
			this.isUpdatingRole = true;
			const userId = this.selectedItem._id;
			const role = this.selectedItem.role;
			const params = {
				role,
			};
			const callback = (response) => {
				this.updateRoleInList(userId, role);
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'User Update Role',
					text: message,
					type: 'success',
				});
				this.isUpdatingRole = false;
				this.isEditRoleVisible = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'User Update Role',
					text: message,
					type: 'danger',
				});
				this.isUpdatingRole = false;
			};
			usersApi.update(userId, params, callback, errorCallback);
		},
		updateEmailInList(userId, email) {
			const index = this.items.findIndex(({ _id }) => _id === userId);
			if (index !== -1) {
				const user = duplicateVar(this.items[index]);
				user.email = email;
				this.$set(this.items, index, user);
			}
		},
		updateRoleInList(userId, role) {
			const index = this.items.findIndex(({ _id }) => _id === userId);
			if (index !== -1) {
				const user = duplicateVar(this.items[index]);
				user.role = role;
				this.$set(this.items, index, user);
			}
		},
		openUserDetails(user) {
			this.userDetail = user;
			this.isDetailsVisible = true;
		},
		showTeamMember(id) {
			console.log('id: ', id);
			this.isDetailsVisible = false;
			this.userDetail = null;
			this.isShowTeamMember = true;
		},
		getIdentityStatus(user) {
			let status = '';
			if (user.identity !== undefined && user.identity.status !== undefined) {
				status = user.identity.status;
			}
			return status;
		},
		getIdentityDisplayStatus(user) {
			let displayStatus = '-';
			switch (this.getIdentityStatus(user)) {
			case 'requested':
				displayStatus = '<div class="status-pill warning">Requested</div>';
				break;
			case 'skipped':
				displayStatus = '<div class="status-pill warning">Skipped</div>';
				break;
			case 'rejected':
				displayStatus = '<div class="status-pill danger">Rejected</div>';
				break;
			case 'approved':
				displayStatus = '<div class="status-pill success">Approved</div>';
				break;
			default:
				break;
			}
			return displayStatus;
		},
		isVerificationEnabled(user) {
			const status = this.getIdentityStatus(user);
			return status === 'requested' || status === 'rejected' || status === 'approved' || status === 'skipped';
		},
		applyFilter() {
			this.fetchItems();
			this.isShowFilter = false;
		},
		followUp(item) {
			this.generateFollowUp(item.data_user, item.data_type);
			this.isFollowUpVisible = true;
		},
		hideFollowUp() {
			this.followUpNumber = '';
			this.followUpName = '';
			this.followUpMessage = '';
			this.isFollowUpVisible = false;
		},
		generateFollowUp(user, type) {
			const phone = user.phone;
			const customerName = user.name || '';
			const followUpMessages = this.followUpMessages !== '' ? this.followUpMessages : defaultFollowUpMessage;
			this.followUpNumber = formatWaNumber(phone);
			this.followUpName = customerName;
			this.followUpMessage = followUpMessages[type].message;
		},
		verifUser(user) {
			this.selectedItem = user;
			this.isModalVerificationVisible = true;
		},
		closeModalVerification() {
			this.verificationModalSource = 'direct';
			this.selectedItem = null;
			this.isModalVerificationVisible = false;
		},
		updateUserIdentity(value) {
			const userId = value.user_id;
			delete value.user_id;
			const selectedUserIndex = this.items.findIndex(user => user._id === userId);
			if (selectedUserIndex !== -1) {
				const users = this.items;
				const selectedUser = users[selectedUserIndex];
				selectedUser.identity = value;
				users[selectedUserIndex] = selectedUser;
				this.items = duplicateVar(users);
			}
		},
		fetchCurrentSetting() {
			this.isFetchingSetting = true;
			const params = this.params;
			const callback = (response) => {
				const settings = response.data;
				this.followUpMessages = settings?.data?.follow_up_text?.user ?? defaultFollowUpMessage;
				this.isFetchingSetting = false;
			};
			const errorCallback = (e) => {
				const msg = getAxiosErrorMessage(e);
				// eslint-disable-next-line
				console.log(msg);
			};
			settingApi.getCurrent(params, callback, errorCallback);
		},
		onSorting(item) {
			this.sort_by = item.sort_by;
			this.sort = item.sort;
			this.fetchItems(true);
		},
		onSelectedItems(item) {
			this.selectedItems = item;
		},
		fetchData() {
			if (this.isAdmin) {
				this.fetchItems();
				this.fetchCurrentSetting();
				this.fetchSourceTypes();
			}
		},
		checkParams() {
			if (this.statusParam) {
				this.identity_status = this.statusParam;
			}
		},
		resetFilter() {
			this.identity_status = 'all';
			this.is_active = 'all';
			this.source_type = 'all';
		},
		clearFilter() {
			this.resetFilter();
			this.$router.replace({ query: null });
			this.fetchUsers();
		},
		fetchUsers() {
			this.checkIdentityStatus();
			this.checkParams();
			this.fetchData();
		},
		openSellerProfile(user) {
			this.selectedItem = user;
			this.isModalSellerProfileVisible = true;
		},
		closeSellerProfile() {
			this.selectedItem = null;
			this.isModalSellerProfileVisible = false;
		},
		openVerificationFromSellerProfile(user) {
			this.closeSellerProfile();
			this.verificationModalSource = 'seller-profile';
			this.verifUser(user);
		},
		openSellerProfileFromVerification(user) {
			this.closeModalVerification();
			this.openSellerProfile(user);
		},
		openSupplierProfile(user) {
			this.selectedItem = user;
			this.isModalSupplierProfileVisible = true;
		},
		closeSupplierProfile() {
			this.selectedItem = null;
			this.isModalSupplierProfileVisible = false;
		},
		closeModalSellerConnection() {
			this.selectedItem = null;
			this.isModalModalSellerConnectionVisible = false;
		},
		openVerificationFromSupplierProfile(user) {
			this.closeSupplierProfile();
			this.verificationModalSource = 'supplier-profile';
			this.verifUser(user);
		},
		openSupplierProfileFromVerification(user) {
			this.closeModalVerification();
			this.openSupplierProfile(user);
		},
		checkPermissions() {
			if (this.activePage === 'staff' && !this.isUserCan('admin_users_staff_view')) {
				this.$router.push('/admin');
			}
		},
		openSellerConnection(user) {
			this.selectedItem = user;
			this.isModalModalSellerConnectionVisible = true;
		},
		openModalServiceFee(userId) {
			const selectedUser = this.items.find(curr => curr._id === userId);
			this.selectedUser = selectedUser;
			this.isShowModalServiceFee = true;
		},
		updateUserServiceFee(user) {
			this.isShowModalServiceFee = false;
			const userIndex = this.items.findIndex(curr => curr._id === user.user_id);
			if (userIndex !== -1) {
				this.items[userIndex].fee_config = {
					type: user.type,
					value: user.value,
				};
			}
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
			isSupport: 'isSupport',
			filterDatePresets: 'filterDatePresets',
			isUserCan: 'isUserCan',
			user: 'user',
		}),
		activePage() {
			return this.$route.params.role;
		},
		selectAll: {
			get() {
				return this.items
					? this.selectedItems.length === this.items.length
					: false;
			},
			set(value) {
				const selected = [];
				if (value) {
					this.items.forEach((item) => {
						selected.push(item._id);
					});
				}
				this.selectedItems = selected;
			},
		},
		sinceQuery() {
			const since = this.$route.query.since;
			return since;
		},
		untilQuery() {
			const until = this.$route.query.until;
			return until;
		},
		statusParam() {
			return this.$route.query.status;
		},
		isFilterOn() {
			return this.identity_status !== 'all'
				|| this.is_active !== 'all'
				|| this.source_type !== 'all';
		},
		userId() {
			return this.$route?.query?.user_id;
		},
	},
	watch: {
		// role_type() {
		// 	if (this.role_type) {
		// 		this.fetchItems();
		// 	}
		// },
		user() {
			this.checkPermissions();
		},
		isAdmin() {
			this.checkPage();
			this.fetchUsers();
		},
		'$route.query': {
			handler() {
				this.checkPage();
				this.fetchUsers();
			},
		},
	},
	created() {
		this.expirationDate = this.moment().format('YYYY-MM-DD');
		this.checkPage();
		this.initFilterDate();
		// Fetch Packages
		this.fetchPackages();
		// Check Params & Fetch Data
		this.fetchUsers();
		// On Scroll Bottom
		window.addEventListener('scroll', this.handleScroll);

		if (this.user) {
			this.checkPermissions();
		}
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>
